// extracted by mini-css-extract-plugin
export default {"productTable":"styles_productTable__oo9d9","title":"styles_title__Hm+K+","header":"styles_header__7aZAa"};